import React from 'react';
import { Form } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';

type FormFieldRenderArgs = {
  id: string;
  isInvalid: boolean;
};

type FormFieldProps = {
  name: string;
  label: React.ReactNode;
  className?: string;

  /**
   * Either:
   * - ReactNode (recommended default), OR
   * - render-prop to access { id, isInvalid }
   */
  children: React.ReactNode | ((args: FormFieldRenderArgs) => React.ReactNode);

  /** Optional helper text under the control */
  helpText?: React.ReactNode;
};

export const FormField = ({ name, label, className, children, helpText }: FormFieldProps) => {
  const {
    formState: { errors },
  } = useFormContext();

  // Your project might already have a utility for this; keep whatever you use.
  const fieldError = (errors as any)?.[name];
  const isInvalid = Boolean(fieldError);

  // If you already have a stable id strategy, use that instead.
  const id = React.useId();

  const content = typeof children === 'function' ? children({ id, isInvalid }) : children;

  return (
    <Form.Group className={className}>
      <Form.Label htmlFor={id}>{label}</Form.Label>
      {content}
      {helpText && <Form.Text className="text-muted">{helpText}</Form.Text>}
      {/* If you currently render invalid feedback here, keep it. Example: */}
      {isInvalid && (
        <Form.Control.Feedback type="invalid" className="d-block">
          {(fieldError as any)?.message?.toString?.() ?? 'Invalid value'}
        </Form.Control.Feedback>
      )}
    </Form.Group>
  );
};
